import toast from "react-hot-toast";
import axios from "../utils/axios";
import Resizer from "react-image-file-resizer";
import Actions from "../store/actions";
import store from "../store/store";


let gallery = {
   allowedPictureFormats: [
      'image/jpg',
      'image/jpeg',
      'image/gif',
      'image/png',
      'image/tiff',
      'image/webp',
      'image/svg+xml',
      'image/x-icon',
      'image/avif',
   ],
   fileSizeResize: (file, type) =>
      new Promise((resolve) => {
         Resizer.imageFileResizer(
            file,
            300,
            300,
            type,
            100,
            0,
            (uri) => {
               resolve(uri);
            },
            "blob"
         );
      }),
   s3UrlMake: (data, useType = "PRODUCTS") => {
      data.useType = useType;
      return axios({
         url: '/v1/admin/gallery',
         method: 'post',
         data,
         headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
         },
      })
   },
   getOnlyFileUrl: (response) => {
      let filePath = response.responseURL.split("?")[0];
      console.log({ filePath })
      return filePath
   },
   getGallery: (page = 1, limit = 20) => axios({
      url: `/v1/admin/gallery?page=${page}&limit=${limit}`,
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   s3UploadLoader: (url, file, progressCallback) => {
      return new Promise(async (resolve, reject) => {
         const xhr = new XMLHttpRequest();
         xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
               if (xhr.status === 200) {
                  resolve(xhr)
               }
               else {
                  reject(xhr)
               }
            }
         };
         if (progressCallback) {
            xhr.upload.onprogress = (e) => {
               if (e.lengthComputable) {
                  var percentComplete = (e.loaded / file.size) * 100;
                  progressCallback(percentComplete);
               }
            };
         }
         xhr.open("PUT", url);
         // if (file.size>(1024 * 1024) / 2){
         // if (file.type == "image/jpg" || file.type == "image/jpeg") {
         //    file = await gallery.fileSizeResize(file, "JPEG")
         // }
         // if (file.type == "image/png") {
         //    file = await gallery.fileSizeResize(file, "PNG")
         // }
         // }
         xhr.send(file);
      });
   },
   uploadFile: async (file, useType = "OTHER") => {
      try {
         if (file) {
            if (gallery?.allowedPictureFormats?.includes(file.type)) {
               let apiData = {
                  fileName: file?.name,
                  fileType: file.type,
                  fileSize: file.size,
               }
               let res = await gallery.s3UrlMake(apiData, useType);
               if (res?.data?.data?.url) {
                  store.dispatch(Actions.addGallery(res?.data?.data?.data));
                  let tostId = toast.loading("Uploading....")
                  let response = await gallery.s3UploadLoader(res.data?.data?.url, file, percent => {
                     console.log(percent);
                     // toast.loading(`Uploading... ${percent}%`);
                  })
                  let filePath = await gallery.getOnlyFileUrl(response);
                  toast.success("Uploaded successfully.", { id: tostId });
                  return filePath
               } else {
                  return ""
               }
            } else {
               toast.error("This file is not allowed to upload.");
               return ""
            }
         } else {
            toast.error("File is required to upload.");
            return ""
         }
      } catch (error) {
         console.log(error.message)
         return ""
      }
   }
}

export default gallery
